import { getAxiosInstance } from "../ApiConfig";

async function FetchAllQuotes(page, limit) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllQuotesByReportingRoleUsers${page ? `?page=${page}&limit=${limit}` : ''}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function AllQuotesPaginationSearch(page, limit, search) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllQuotesByReportingRoleUsers?page=${page}&limit=${limit}&search=${search}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function AllQuotesSearch(search) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllQuotesByReportingRoleUsers?search=${search}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function getCompanyQuotes() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllQuotesByCompany`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function FetchQuoteDetails(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findOneByQuotes/${id}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchQuotesByDeal(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getAllQuotesByDealId/${id}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function deleteQuotes(id) {
    try {
        const data = await getAxiosInstance().delete(`/usermgmt/deleteQuotes/${id}`);
        return data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function createQuotes(payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/createQuotes`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function updateQuotes(payload, id) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/updateQuotes/${id}`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
export {
    createQuotes,
    updateQuotes,
    FetchAllQuotes,
    getCompanyQuotes,
    FetchQuoteDetails,
    FetchQuotesByDeal,
    deleteQuotes,
    AllQuotesPaginationSearch,
    AllQuotesSearch,
}